// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mail-client .w-card-title[data-v-6934e0a4] {\n  background: var(--main-gray-1);\n}\n.mail-client .w-card-title svg[data-v-6934e0a4] {\n  margin: 5px 5px 0 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
